import axios from "axios";
import Vue from "vue";
import qs from "qs";
import cache from "@/plugins/cache";
import { Notification, MessageBox, Message, Loading } from "element-ui";
import errorCode from "@/utils/errorCode";
// import { router } from "vue-router";
let downloadLoadingInstance;
// 是否显示重新登录
export const isRelogin = { show: false };

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建实例
const service = axios.create({
  //baseURL: process.env.VUE_APP_API_URL, // 接口基础地址
  // baseURL: "http://192.87.18.32:8080",
  // baseURL: "http://192.87.18.34/api",
  // baseURL: "http://192.87.18.34/prod-api",
  // baseURL: "http://wenchuangdev.laohui.net",
  baseURL: "/api", //学校服务
  timeout: 30000, // 响应超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 挂在token, 根据自己方式判断和自定义参数
    if (sessionStorage.getItem("token")) {
      config.headers["Authorization"] = sessionStorage.getItem("token");
    }
    // 不同请求方式 所用type不同
    if (!config.headers["Content-Type"]) {
      if (config.method == "post" || config.method == "POST") {
        // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
        // config.data = qs.stringify(config.data); // 请求参数序列化
        const requestObj = {
          url: config.url,
          data:
            typeof config.data === "object"
              ? JSON.stringify(config.data)
              : config.data,
          time: new Date().getTime(),
        };
        const sessionObj = cache.session.getJSON("sessionObj");
        if (
          sessionObj === undefined ||
          sessionObj === null ||
          sessionObj === ""
        ) {
          cache.session.setJSON("sessionObj", requestObj);
        } else {
          const s_url = sessionObj.url; // 请求地址
          const s_data = sessionObj.data; // 请求数据
          const s_time = sessionObj.time; // 请求时间
          const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
          if (
            s_data === requestObj.data &&
            requestObj.time - s_time < interval &&
            s_url === requestObj.url
          ) {
            const message = "数据正在处理，请勿重复提交";
            console.warn(`[${s_url}]: ` + message);
            return Promise.reject(new Error(message));
          } else {
            cache.session.setJSON("sessionObj", requestObj);
          }
        }
      } else {
        config.headers["Content-Type"] = "application/json; charset=utf-8";
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // console.log(res);
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data;
    }
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true;
        MessageBox.confirm(
          "登录状态已过期，您可以继续留在该页面，或者重新登录",
          "系统提示",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            console.log("login", 1);
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            setTimeout(() => {
              window.location.href = "/#/home";
              window.location.reload();
            }, 500);

            isRelogin.show = false;
            // store.dispatch("LogOut").then(() => {
            //   location.href = "/index";
            // });
          })
          .catch(() => {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            setTimeout(() => {
              window.location.href = "/#/home";
              window.location.reload();
            }, 500);
            isRelogin.show = false;
          });
      }
      // return Promise.reject("无效的会话，或者会话已过期，请重新登录。");
      return;
    } else if (code === 500) {
      Message({ message: msg, type: "error" });
      // return Promise.reject(new Error(msg));
      return;
    } else if (code === 601) {
      Message({ message: msg, type: "warning" });
      // return Promise.reject(code);
      return;
    } else if (code !== 200) {
      Notification.error({ title: msg });
      // return Promise.reject("error");
      return;
    } else {
      return res.data;
    }
  },
  (error) => {
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: "error", duration: 5 * 1000 });
    // return Promise.reject(error);
    return;
  }
);

export default service;
